import { ToolbarItemProps } from '../../store/slice';
import React from 'react';
import { MoreToolsGroup, MoreToolsItem } from './styles';

const MoreToolsView: React.VFC<ToolbarItemProps> = (item) => {
  return (
    <>
      {item.sidebarGroups.map((group) => (
        <MoreToolsGroup key={group.title}>
          <h5>{group.title}</h5>
          {group.links.map((sideNavLinkProp) => (
            <MoreToolsItem
              data-takt-id={sideNavLinkProp.id}
              href={sideNavLinkProp.link.url}
              key={sideNavLinkProp.id}
            >
              {sideNavLinkProp.link.label}
            </MoreToolsItem>
          ))}
        </MoreToolsGroup>
      ))}
    </>
  );
};

export default MoreToolsView;
